<div class="custom-dropdown border-radius radius-top-right spacing-16">
  <div class="d-flex flex-column spacing-12 w-100">
    <div class="heading d-flex align-items-center justify-content-between w-100">
      <span class="h3-bold primary-100">Properties </span>
      <!--TODO-- <app-link-btn
        label="Hide all"
        [active]="false"
        size="large"
        IconType="none"
        [disabled]="false"
        (onSelect)="onClearAll()">
      </app-link-btn> -->
    </div>
    @if (search) {
      <div
        class="w-100"
        app-search
        [active]="false"
        placeholder="Search filters..."
        [SearchBtn]="false"
        [disabled]="false"
        size="medium"
        [searchString]="searchString"
        (onSearch)="onSearch($event)"></div>
    }
  </div>
  <div class="filter-dropdown h3-bold primary-100 m-0">
    @for (item of dataList; track item; let i = $index) {
      <dropdown-single-piece
        [id]="'dd' + i"
        [label]="item.label"
        [color]="'default'"
        [type]="'bold'"
        [state]="'default'"
        [icon]="true"
        [iconType]="item.icon"
        [dragDrop]="false"
        [toggle]="true"
        [more]="false"
        [radio]="false"
        [value]="item.isShow"
        (onAction)="handlePropertyChange(item)"></dropdown-single-piece>
    }
  </div>
</div>
